export default __webpack_public_path__ + "static/media/8.7a24d89d.png";